import React from 'react';

import { PortalRegistrationStep } from '@commonTuna/react/objects/PortalRegistrationStep';

interface Props {
	steps: Array<PortalRegistrationStep>;
	onOk: () => void;
}

const Congratulations: React.FC<Props> = ({ onOk, steps }) => {
	return <div
		className="text-center"
		style={{
			background: 'white',
			padding: 10,
			borderRadius: '4px',
		}}
	>
		<div>
			<i
				style={{
					display: 'block',
					margin: '0 auto 30px',
					color: '#52c41a',
					fontSize: 40,
					border: '5px solid #52c41a',
					borderRadius: '50%',
					padding: 10,
					width: 70,
					height: 70,
				}}
				className="fa fa-check"
			/>
		</div>
		<h1 style={{ marginBottom: 30, fontSize: 35 }}>Congratulations!</h1>
		<h3 style={{ fontSize: 20 }}>
			You patient profile have been successfully created.
			<br />
			<br />
			{steps.length > 1
				? 'To finish registration process you need go through last few steps.'
				: ''}
		</h3>
		<button
			type="button"
			className="btn btn-primary mt10"
			onClick={() => onOk()}
		>
			Continue
		</button>
	</div>;
};

export default Congratulations;
